import { Injectable } from '@angular/core';
import { AlbumGroupeTextField, AlbumGroupeModel } from '@core/models/ce/album_groupe-model';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { ApiUrl } from '@shared/tools/constants/api.endpoints';
import { EnumAction } from '@shared/tools/enums/enum-status.enum';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { DeviceAppVersionTextField } from '@core/models/device-app-version-model';

@Injectable({
  providedIn: 'root'
})
export class DeviceAppVersionService extends UnsubscribeOnDestroyAdapter {

  endpoint: string = ApiUrl.DeviceAppVersionV1;
  public textField=DeviceAppVersionTextField;
  public loadingDeviceAppVersionDataList=false;
  public albumGroupeDataList: AlbumGroupeModel[]  = [];

  constructor( private apiService: ApiService, public authorizationService: AuthorizationService,) {super();}

  // getAll(data?: any) : Observable<any>{
  //   return this.apiService.getData(`${this.endpoint}`, data );
  // }
  getAllPaginate( data?: any) : Observable<any>{
    return this.apiService.getData(`${this.endpoint}/paginate`, data );
  }

  getOne( id: string ) : Observable<any> {
    return this.apiService.getData(`${this.endpoint}/${id}` );
  }

  insert( data: any ) : Observable<any>{
    return this.apiService.postData(`${this.endpoint}`, data, );
  }

  update(  data: any ) : Observable<any>{
    return this.apiService.putData(`${this.endpoint}`, data, );
  }
  saves( isNew: boolean, data: any ) : Observable<any>{
    if( isNew ){
      return this.insert(data);
    }
    return this.update(data);
  }

  delete( id: string ) : Observable<any>{
    return this.apiService.deleteData(`${this.endpoint}/${id}` );
  }

  deleteFile( id: string, enumAction: EnumAction ) : Observable<any>{
    if( EnumAction.AUDIO==enumAction ){
      return this.apiService.patchData(`${this.endpoint}?id=${id}&isAudio=true` );
    }
    return this.apiService.patchData(`${this.endpoint}?id=${id}&isAudio=false` );
  }

}
